export default "__VITE_ASSET__DDCChzU6__"